import { AtlasMark } from './Nav';
import { useSectionNav, scrollToTop } from '../lib/atlas';

export default function Footer() {
  const goTo = useSectionNav();

  return (
    <footer className="relative border-t border-white/[0.06] px-6 lg:px-16 py-12" data-testid="footer">
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row md:items-end justify-between gap-8">
        <div>
          <div className="flex items-center gap-2.5">
            <AtlasMark className="w-5 h-5" />
            <span className="font-syne font-bold tracking-[0.18em] text-[12px] text-white">
              THE CREATIVE ATLAS
            </span>
          </div>
          <p className="mt-4 text-sm text-slate-500">Designed for global exploration.</p>
        </div>

        <nav className="flex flex-wrap gap-x-7 gap-y-3">
          {[
            ['Home', 'top'],
            ['Explore', 'explore'],
            ['About', 'about'],
            ['Contact', 'contact'],
          ].map(([label, id]) => (
            <button
              key={id}
              onClick={() => (id === 'top' ? scrollToTop() : goTo(id))}
              data-testid={`footer-link-${id}`}
              className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 hover:text-white transition-colors"
            >
              {label}
            </button>
          ))}
        </nav>
      </div>

      <div className="max-w-[1400px] mx-auto mt-10 pt-6 border-t border-white/[0.05]">
        <p className="font-mono text-[10px] tracking-[0.2em] text-slate-600 uppercase">
          © 2026 Karan Soni. The Creative Atlas.
        </p>
      </div>
    </footer>
  );
}
